import { ReactNode } from 'react';
import * as styles from '../../../styles/weave-pay.styles';

export const IconTextWrapper = (props: { children?: ReactNode }) => (
  <div css={styles.iconTextWrapper}>{props.children}</div>
);
